var SLICK_STRINGS = window.accessibilityStrings || {};
var SLICK_ARROW_PATHS = '<path d="M9.57007 5.93018L3.50007 12.0002L9.57007 18.0702" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 12H3.67" stroke="#F45D2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>';

function slickArrow(id, label, svgStyle) {
    return '<button type="button" id="' + id + '" class="custom-arrow" aria-label="' + String(label).replace(/"/g, '&quot;') + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"' + (svgStyle ? ' style="' + svgStyle + '"' : '') + '>' +
        SLICK_ARROW_PATHS + '</svg></button>';
}

var SLICK_PREV_ARROW = slickArrow('slick-prev', SLICK_STRINGS.previousSlide || 'Previous slide');
var SLICK_NEXT_ARROW = slickArrow('slick-next', SLICK_STRINGS.nextSlide || 'Next slide', 'transform: rotate(180deg);');

// Accessibility fixes applied to every slick carousel, including the ones initialized inline in sections.
// - A <ul role="list"> turned into a slider gets slick wrapper divs (and sometimes arrow buttons) as children,
//   which breaks the list role, so the slider becomes a group and the wrapped <li>s become presentational.
// - Arrow buttons get type="button" and an accessible name.
// - slick sets aria-hidden on a slide when a transition starts but only updates tabindex inside it when the
//   transition ends (never, mid-marquee), so focusable content inside hidden slides is kept at tabindex -1.
var SLICK_FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

function syncSlickSlideFocus(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    slide.querySelectorAll(SLICK_FOCUSABLE).forEach(function (el) {
        var current = el.getAttribute('tabindex');
        if (hidden) {
            if (current === '-1') return;
            el.setAttribute('data-slick-a11y-tabindex', current === null ? '' : current);
            el.setAttribute('tabindex', '-1');
        } else if (el.hasAttribute('data-slick-a11y-tabindex')) {
            // Only restore what we changed; if slick has already re-enabled the element, leave its value.
            if (current === '-1') {
                var original = el.getAttribute('data-slick-a11y-tabindex');
                if (original === '') el.removeAttribute('tabindex');
                else el.setAttribute('tabindex', original);
            }
            el.removeAttribute('data-slick-a11y-tabindex');
        }
    });
}

function setupSlickA11y(slick) {
    var slider = slick && slick.$slider && slick.$slider[0];
    if (!slider) return;

    if (slider.matches('ul, ol, [role="list"]') && slider.getAttribute('data-slick-a11y-role') === null) {
        slider.setAttribute('data-slick-a11y-role', slider.getAttribute('role') || '');
        slider.setAttribute('role', 'group');
    }
    slider.querySelectorAll('li.slick-slide, .slick-slide li').forEach(function (li) {
        if (!li.parentElement.matches('ul, ol')) {
            li.setAttribute('role', 'none');
            li.setAttribute('data-slick-a11y-li', '');
        }
    });

    [[slick.$prevArrow, SLICK_STRINGS.previousSlide || 'Previous slide'], [slick.$nextArrow, SLICK_STRINGS.nextSlide || 'Next slide']].forEach(function (pair) {
        var arrow = pair[0] && pair[0][0];
        if (!arrow || arrow.tagName !== 'BUTTON') return;
        if (!arrow.hasAttribute('type')) arrow.setAttribute('type', 'button');
        if (!arrow.hasAttribute('aria-label') && !arrow.textContent.trim()) arrow.setAttribute('aria-label', pair[1]);
    });

    slider.querySelectorAll('.slick-slide').forEach(syncSlickSlideFocus);

    if (!slider.slickA11yObserver) {
        slider.slickA11yObserver = new MutationObserver(function (records) {
            records.forEach(function (record) {
                if (record.target.classList.contains('slick-slide')) syncSlickSlideFocus(record.target);
            });
        });
        slider.slickA11yObserver.observe(slider, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    }
}

function teardownSlickA11y(slick) {
    var slider = slick && slick.$slider && slick.$slider[0];
    if (!slider) return;
    if (slider.slickA11yObserver) {
        slider.slickA11yObserver.disconnect();
        slider.slickA11yObserver = null;
    }
    var role = slider.getAttribute('data-slick-a11y-role');
    if (role !== null) {
        if (role) slider.setAttribute('role', role);
        else slider.removeAttribute('role');
        slider.removeAttribute('data-slick-a11y-role');
    }
    slider.querySelectorAll('[data-slick-a11y-li]').forEach(function (li) {
        li.removeAttribute('role');
        li.removeAttribute('data-slick-a11y-li');
    });
    slider.querySelectorAll('[data-slick-a11y-tabindex]').forEach(function (el) {
        var original = el.getAttribute('data-slick-a11y-tabindex');
        if (original === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', original);
        el.removeAttribute('data-slick-a11y-tabindex');
    });
}

// slick's events bubble, so one document-level listener covers every slider on the page.
jQuery(document).on('init reInit breakpoint', function (event, slick) { setupSlickA11y(slick); });
jQuery(document).on('destroy', function (event, slick) { teardownSlickA11y(slick); });

// Runs callback once el comes within 400px of the viewport. Used to start carousels far down the page lazily:
// each slick() init forces layout, so starting them all on page load showed up as "forced reflow".
window.whenNearViewport = function (el, callback) {
    if (!el || !('IntersectionObserver' in window)) return callback();
    var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        callback();
    }, { rootMargin: '400px 0px' });
    observer.observe(el);
};

jQuery(document).ready(function($){
    // Catch sliders that were initialized before this file ran.
    $('.slick-initialized').each(function () { if (this.slick) setupSlickA11y(this.slick); });

    if($(window).width() <= 1024){
        $('.collection .contains-card--product.contains-card--standard').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            prevArrow: SLICK_PREV_ARROW,
            nextArrow: SLICK_NEXT_ARROW,
            dots: false,
            responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 2.5 } },
            { breakpoint: 600, settings: { slidesToShow: 2.5 } },
            { breakpoint: 480, settings: { slidesToShow: 1.2 } }
            ]
        });
    }

    if($(window).width() <= 650){
        $('.bottom-bar .flex').slick({
          speed: 4000,             // Long duration for smooth continuous scroll
          autoplay: true,
          autoplaySpeed: 0,        // No delay between slides
          cssEase: 'linear',       // Smooth linear motion, no easing
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          pauseOnHover: true,
          pauseOnFocus: true,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });

    }
    // if($(window).width() <= 1024){
       $('.collection-list.contains-card.contains-card--collection').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 7,
        arrows: true,
        prevArrow: SLICK_PREV_ARROW,
        nextArrow: SLICK_NEXT_ARROW,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              centerMode: true,
              centerPadding: '60px',
              slidesToShow: 3,
              arrows: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '100px',
              slidesToShow: 1
            }
          }
        ]
      });
    // }

    if($(window).width() <= 1200){
        $('.product-info-boxes').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            prevArrow: SLICK_PREV_ARROW,
            nextArrow: SLICK_NEXT_ARROW,
            dots: false,
            responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 2.5 } },
            { breakpoint: 600, settings: { slidesToShow: 2.5 } },
            { breakpoint: 480, settings: { slidesToShow: 1, centerMode: true, centerPadding: '60px' } }
            ]
        });
    }

    // $('.collection-list.contains-card.contains-card--collection').slick({
    //     slidesToShow: 7,
    //     slidesToScroll: 1,
    //     infinite: false,
    //     autoplay: false,
    //     autoplaySpeed: 3000,
    //     arrows: false,
    //     dots: false,
    //     responsive: [
    //     { breakpoint: 1024, settings: { slidesToShow: 5 } },
    //     { breakpoint: 768, settings: { slidesToShow: 2.5 } },
    //     { breakpoint: 600, settings: { slidesToShow: 2.5 } },
    //     { breakpoint: 480, settings: { slidesToShow: 1.2 } }
    //     ]
    // });

    if($(window).width() <= 1024){
      setTimeout(() => {
        
      
        $('product-recommendations.related-products .product-grid').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            prevArrow: SLICK_PREV_ARROW,
            nextArrow: SLICK_NEXT_ARROW,
            dots: false,
            responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 2.5 } },
            { breakpoint: 600, settings: { slidesToShow: 2.5 } },
            { breakpoint: 480, settings: { slidesToShow: 1.2 } }
            ]
        });

        }, 10000);
    }

    if($(window).width() <= 650){
     
        
      
        $('.blog__posts.articles-wrapper').slick({
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: 1,
            arrows: true,
            prevArrow: SLICK_PREV_ARROW,
            nextArrow: SLICK_NEXT_ARROW,
            dots: false,
            // responsive: [
            // { breakpoint: 1024, settings: { slidesToShow: 4 } },
            // { breakpoint: 768, settings: { slidesToShow: 2.5 } },
            // { breakpoint: 600, settings: { slidesToShow: 2.5 } },
            // { breakpoint: 480, settings: { slidesToShow: 1.2 } }
            // ]
        });

        
    }

   $('.association_boxes').each(function () {
    var $boxes = $(this);
    window.whenNearViewport(this, function () {
     $boxes.slick({
      autoplay: true,
      autoplaySpeed: 2000,
      dots: false,
      infinite: true,
      arrows: false,
     });
    });
   });
   
})

document.addEventListener("DOMContentLoaded", function () {
    if(window.outerWidth < 750){
    const headings = document.querySelectorAll(".footer-block .heading-with-arrow");

    headings.forEach((heading) => {
        heading.addEventListener("click", function () {
        const parentBlock = heading.closest(".footer-block");
        const content = parentBlock.querySelector(".footer-block__details-content");

        // Toggle visibility
        content.classList.toggle("active");

        // Optional: toggle arrow rotation
        heading.classList.toggle("open");
        });
    });
  }
});